/**
 * @packageDocumentation
 * @module HackerAPI.Notification
 */
import { __extends } from "tslib";
import Base from "../base/base";
import HackerAPIFetch from "../hackerapi-fetch/hackerapi-fetch";
import { parseDate } from "../utils/utils";
/**
 * @class
 * @extends { HackerAPI.Base }
 */
var Notification = /** @class */ (function (_super) {
    __extends(Notification, _super);
    /**
     * Creates a new notification instance
     * @constructor
     * @param notif
     */
    function Notification(_a) {
        var _b = _a === void 0 ? {} : _a, title = _b.title, contents = _b.contents, time = _b.time, category = _b.category;
        var _this = _super.call(this, {
            time: Base.dateTimeHandler
        }) || this;
        /**
         * Notification title
         * @type { string }
         */
        _this.title = title;
        /**
         * Notification body
         * @type { string }
         */
        _this.contents = contents;
        /**
         * The time to send the notification (null for now)
         * @type { Date }
         */
        _this.time = parseDate(time);
        /**
         * What kind of notification is this
         * @type { string }
         */
        _this.category = category;
        return _this;
    }
    /**
     * Tells hackerapi to send a notification
     * @param notif
     * @param [token]
     * @returns
     */
    Notification.send = function (notif, token) {
        return HackerAPIFetch({
            path: "/v2/pushNotifications",
            method: "POST",
            body: notif.toHackerAPIFormat(),
            token: token
        });
    };
    return Notification;
}(Base));
export default Notification;
//# sourceMappingURL=notification.js.map